import { CenteredFlexRow, FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export const KeyIndicatorsPopWrapper = styled(FlexColumn)`
    width: auto;
    height: 100%;
`;

export const TotalVisitsContainer = styled(CenteredFlexRow)`
    width: 50%;
    height: 100%;
`;

export const CubeContainer = styled(FlexColumn)`
    gap: 8px;
    width: 50%;
`;

export const ContentContainer = styled(FlexRow)`
    justify-content: space-between;
    flex-grow: 1;
    padding: 8px;

    @media (max-width: 1100px) {
        ${TotalVisitsContainer} {
            width: 44%;
        }
        ${CubeContainer} {
            width: 56%;
        }
    }
`;

export const CubeRow = styled(FlexRow)`
    display: flex;
    height: 100%;
    gap: 8px;
`;

export const NoDataContainer = styled(CenteredFlexRow)`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    height: 300px;
`;
